import { Text, SegmentedControl, SegmentedControlProps } from "@mantine/core";

interface Props extends SegmentedControlProps {
  label?: string;
}

export const GuestStatusSegmentedControl = (props: Partial<Props>) => {
  return (
    <>
      {props.label && (
        <Text size="sm" fw={500} mb={3}>
          {props.label}
        </Text>
      )}
      <SegmentedControl
        {...props}
        data={[
          { label: "Undecided", value: "u" },
          { label: "Accepted", value: "a" },
          { label: "Declined", value: "d" },
        ]}
      />
    </>
  );
};
